export default "__VITE_ASSET__CdPEUeMO__"